import styled, { keyframes } from 'styled-components';
import StrippedBackElement from '../../../utils/strippedBackElement';
import SpinnerSVG from '../../../../assets/rebrand/loaders/spinner-loader.svg';

const animation = keyframes`
  fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const Spinner = styled(StrippedBackElement).attrs({
  element: 'img'
})`
  align-items: center;
  display: flex;
  flex-direction: column;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  animation: ${animation} fade-in 0.3s forwards;
`;

Spinner.defaultProps = {
  src: SpinnerSVG
};
